import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Control } from '../../../models/control';


import { DeleteadvisorDialog} from './dialogs/delete-advisor/delete-advisor.dialog';
import { LockSettingsDialogAdvisor } from './dialogs/lock-settings/lock-settings-advisor.dialog';
import { ConfigureHoursDialogAdvisors } from './dialogs/configure-hours/configure-hours-advisor.dialog';
import { EditInfoDialogadvisor} from './dialogs/edit-info/edit-info-advisor.dialog';

import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { finalize, Observable, tap, map, forkJoin, catchError, throwError } from 'rxjs';
import { MatPaginatorIntl as MatPaginatorIntl, PageEvent as PageEvent } from '@angular/material/paginator';
import { CustomPaginator } from '../CustomPaginatorConfiguration';
import { HelperService } from 'src/services/helperService';
import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { Workshop } from 'src/models/workshop';
import { TranslateService } from '@ngx-translate/core';
import { AdvisorManagement, ManagementBrand } from 'src/models/workshopsManagement.interface';


@Component({
    selector: 'app-advisors',
    templateUrl: './advisors.component.html',
    styleUrls: ['./advisors.component.sass'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ],
    standalone: false
})
export class AdvisorsComponent implements OnInit {

  onAddControlClick = (param: string): void => {}
  serviceAdvisors$ = new Observable<AdvisorManagement[]>()
  workshopInformation = new Observable<Workshop[]>()
  modalInformation$ = new Observable<[AdvisorManagement[], Workshop[]]>()
  pagesize:number = 16
  from:number = 0
  to:number = 16
  Workshop: Workshop [] = []
  pagesCount: number = 0;
  selectedPage: number = 0;
  rowPerPage: number = 16
  userRoleOptional :number = this.helperService.user.retailId ?this.helperService.user.retailId: this.helperService.user.workshopId
  FilterByName = '';
  FilterByBrand =''
  FilterByWorkshop =''
  FilterByTypeOfService =''
  advisorsListLength: number = 0;

  controls: Control[] = [
    {
      icon: 'bi bi-plus-lg',
      description: 'Add Advisor',
      action: this.onAddControlClick
    },
  ];

  constructor(
    public WorkshopService: APIWorkshopService,
    public helperService: HelperService,
    public dialog: MatDialog,
    public brandsService: APIBrandsService,
    public ServiceAdvisorApi: APIServiceAdvisorService,
    private translate: TranslateService)
  {}


  ngOnInit(): void {
    this.from= 0
    this.to = this.pagesize
    this.helperService.TitlePage = 'AdminAsesores'
    this.helperService.icon = "edit"
    if(this.helperService.user.role.roleId === 4 ){
      this.userRoleOptional = this.helperService.user.retailId
    }
    else {
      this.userRoleOptional = this.helperService.user.workshopId
    }
    this.workshopInformation= this.WorkshopService?.getManagement(this.helperService.user.role.roleId,this.userRoleOptional).pipe(
      tap(
        (next)=>{
          this.Workshop= next
        }
      ), catchError((error: any) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }

        return throwError(() => error);

      })
    )
    this.serviceAdvisors$ = this.ServiceAdvisorApi?.getManagementAdvisor(
      this.helperService.user.role.roleId, this.userRoleOptional
    ).pipe(
      map((serviceAdvisors) => {

        this.advisorsListLength= serviceAdvisors.length
        serviceAdvisors.forEach((advisor) => {
          advisor.services = advisor.services.map((service) => {
            return {...service, serviceName: this.translate.instant(service.serviceName)};
          });
        });
        return serviceAdvisors;
      }), catchError((error: any) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }

        return throwError(() => error);

      })
    );
    this.modalInformation$ = forkJoin([this.serviceAdvisors$,this.workshopInformation])
  }




 // Funtions filter and pagination



  changePage(e:PageEvent)
  {
    this.from = e.pageIndex * e.pageSize;
    this.to = this.from + e.pageSize
  }

// Funtion Change state workshop

  onToggleAdvisorActive(DataInt:any) {
    const advisor:any ={
      advisorId: DataInt.advisorId,
      advisorFullName: DataInt.advisorName,
      phoneNumber: DataInt.documentNumber,
      isActive: !DataInt.isActive,
      sapAdvisorId: DataInt.sapAdvisorId
    }

    this.ServiceAdvisorApi?.put(advisor).pipe(finalize( () =>  this.ngOnInit())).subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      })
  }

  // Funtion show icons hover

  onIconMouseHoverAndOut(elementId: string, className: string, isFill: boolean) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }

// Functions to dynamic filter

setClickedBrand(brand:any){
  this.FilterByWorkshop = brand.workshopName
}

 // Functions to open workshop dialogs

  onEditInformationClick(advisor?: AdvisorManagement) {
      const modalData = {
        workshop:this.Workshop,
        advisor
      }
    const dialogRef = this.dialog.open(EditInfoDialogadvisor, {
      width: '550px',
      panelClass: 'icon-outside',
      data: modalData,
    });
    dialogRef.afterClosed().subscribe(result => {
     this.ngOnInit()
    });

  }

  onConfigureHoursClick(advisor) {
    if(advisor.isActive){
      const dialogRef = this.dialog.open(ConfigureHoursDialogAdvisors, {
        width: '1270px',
        panelClass: 'icon-outside',
        data: advisor,
      });
        dialogRef.afterClosed().subscribe(result => {
      });
    }
   else{
    const translateText = this.translate.instant(
      'ToastDesactiveAdvisor',
      {
        fullName:advisor.advisorName
      }
     );
    this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =translateText

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)
   }
  }
  onDeleteAdvisorClick(advisor) {
    const dialogRef = this.dialog.open(DeleteadvisorDialog, {
      width: '491px',
      panelClass: 'icon-outside',
      data: advisor,
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result === 'DeleteData'){


        }

    });

  }
  onLockSettingsClick(advisor) {
    if(advisor.isActive){
      const dialogRef = this.dialog.open(LockSettingsDialogAdvisor, {
        // width: '1217px',
        panelClass: 'icon-outside',
        data: advisor,
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  else{
    const translateText = this.translate.instant(
      'ToastDesactiveAdvisor',
      {
        fullName:advisor.advisorName
      }
     );
    this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =translateText

        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)
  }
  }
}







